import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import { useHistory } from "../web_modules/react-router-dom.js";
import { AsyncStates, useAsyncStatus } from "../web_modules/use-async-status.js";
import { API_HOST, buttonCheckMark, getOrderSummaryFromPurchase, getThemedButton, makeTbRequestHeaders, styles, useLanguage } from "./app.js";
import { LoadingButton } from "../web_modules/@ticketbutler/toolbox.js";
import { useTranslation } from "../web_modules/react-i18next.js";
import climaiderIcon from "./assets/icons/climaider.svg";
const servicesStyles = {
  textBold: {
    fontWeight: "bold",
    fontSize: 15
  },
  textSmall: {
    fontSize: 13,
    lineHeight: 1.5
  }
};

function getRadioInputButtonStyles(theme) {
  const buttonStyle = { ...getThemedButton(theme, {
      outline: true
    }),
    width: "100% !important",
    minWidth: "0 !important"
  };
  return {
    width: "100%",
    "> div": buttonStyle,
    "> input:checked + div": {
      backgroundColor: theme.colour_primary,
      color: theme.custom_button_text_color ? theme.custom_button_text_color : "white"
    },
    "> input": {
      opacity: "0",
      position: "absolute",
      width: "220px",
      height: "55px"
    }
  };
}

var _StyledDiv = _styled("div").withConfig({
  displayName: "services___StyledDiv",
  componentId: "e8sx9c-0"
})({
  maxWidth: 460,
  margin: "auto"
});

var _StyledForm = _styled("form").withConfig({
  displayName: "services___StyledForm",
  componentId: "e8sx9c-1"
})({
  fieldset: {
    borderStyle: "none",
    marginTop: 30
  }
});

var _StyledP = _styled("p").withConfig({
  displayName: "services___StyledP",
  componentId: "e8sx9c-2"
})(["", ""], p => p._css);

var _StyledU = _styled("u").withConfig({
  displayName: "services___StyledU",
  componentId: "e8sx9c-3"
})({
  color: "blue",
  cursor: "pointer"
});

var _StyledP2 = _styled("p").withConfig({
  displayName: "services___StyledP2",
  componentId: "e8sx9c-4"
})(["", ""], p => p._css2);

var _StyledP3 = _styled("p").withConfig({
  displayName: "services___StyledP3",
  componentId: "e8sx9c-5"
})(["", ""], p => p._css3);

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "services___StyledDiv2",
  componentId: "e8sx9c-6"
})({
  display: "flex"
});

var _StyledLabel = _styled("label").withConfig({
  displayName: "services___StyledLabel",
  componentId: "e8sx9c-7"
})(["", ""], p => p._css4);

var _StyledInput = _styled("input").withConfig({
  displayName: "services___StyledInput",
  componentId: "e8sx9c-8"
})(["", ""], p => p._css5);

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "services___StyledDiv3",
  componentId: "e8sx9c-9"
})(["", ""], p => p._css6);

var _StyledLabel2 = _styled("label").withConfig({
  displayName: "services___StyledLabel2",
  componentId: "e8sx9c-10"
})(["", ""], p => p._css7);

var _StyledInput2 = _styled("input").withConfig({
  displayName: "services___StyledInput2",
  componentId: "e8sx9c-11"
})(["", ""], p => p._css8);

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "services___StyledDiv4",
  componentId: "e8sx9c-12"
})(["", ""], p => p._css9);

var _StyledP4 = _styled("p").withConfig({
  displayName: "services___StyledP4",
  componentId: "e8sx9c-13"
})(["", ""], p => p._css10);

var _StyledP5 = _styled("p").withConfig({
  displayName: "services___StyledP5",
  componentId: "e8sx9c-14"
})(["", ""], p => p._css11);

var _StyledP6 = _styled("p").withConfig({
  displayName: "services___StyledP6",
  componentId: "e8sx9c-15"
})(["", ""], p => p._css12);

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "services___StyledDiv5",
  componentId: "e8sx9c-16"
})({
  display: "flex"
});

var _StyledLabel3 = _styled("label").withConfig({
  displayName: "services___StyledLabel3",
  componentId: "e8sx9c-17"
})(["", ""], p => p._css13);

var _StyledInput3 = _styled("input").withConfig({
  displayName: "services___StyledInput3",
  componentId: "e8sx9c-18"
})(["", ""], p => p._css14);

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "services___StyledDiv6",
  componentId: "e8sx9c-19"
})(["", ""], p => p._css15);

var _StyledLabel4 = _styled("label").withConfig({
  displayName: "services___StyledLabel4",
  componentId: "e8sx9c-20"
})(["", ""], p => p._css16);

var _StyledInput4 = _styled("input").withConfig({
  displayName: "services___StyledInput4",
  componentId: "e8sx9c-21"
})(["", ""], p => p._css17);

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "services___StyledDiv7",
  componentId: "e8sx9c-22"
})(["", ""], p => p._css18);

var _StyledP7 = _styled("p").withConfig({
  displayName: "services___StyledP7",
  componentId: "e8sx9c-23"
})(["", ""], p => p._css19);

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "services___StyledDiv8",
  componentId: "e8sx9c-24"
})({
  display: "flex",
  justifyContent: "center"
});

var _StyledImg = _styled("img").withConfig({
  displayName: "services___StyledImg",
  componentId: "e8sx9c-25"
})({
  width: 140
});

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "services___StyledDiv9",
  componentId: "e8sx9c-26"
})({
  justifyContent: "center",
  display: "flex",
  marginTop: 30
});

var _StyledButton = _styled("button").withConfig({
  displayName: "services___StyledButton",
  componentId: "e8sx9c-27"
})(["", ""], p => p._css20);

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "services___StyledDiv10",
  componentId: "e8sx9c-28"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: 20
});

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "services___StyledDiv11",
  componentId: "e8sx9c-29"
})(["", ""], p => p._css21);

export function Services({
  whitelabel,
  theme,
  reservation,
  setOrderSummary,
  setReservation,
  onSuccess,
  event
}) {
  const history = useHistory();
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const insuranceOptionAvailable = whitelabel.insurance_active && !reservation.purchase.pay_by_invoice && !reservation.purchase.purchase_is_free && !event.eventsettings.invoice_payment_only && !event.eventsettings.invoice_payment_optional && event.event_type !== "GIFT_CARD"; //get the amount for the insurance cost

  const {
    trigger: getInsuranceInformation,
    lastResult: insuranceInformation = {
      price: undefined,
      insuranceTermsAndConditionsUrl: undefined
    },
    status: insuranceInformationStatus
  } = useAsyncStatus(async () => {
    const req = await fetch([API_HOST, "purchases", reservation.purchase.uuid, "insurance/"].join("/"), {
      headers: makeTbRequestHeaders(language)
    });

    if (req.ok) {
      const res = await req.json(); //set the calculated amount of insurance cost

      return {
        price: res.productOfferings[0].premium,
        insuranceTermsAndConditionsUrl: res.productOfferings[0].wording.termsAndConditionsUrl
      };
    } else {
      throw Error();
    }
  }, []);
  React.useEffect(() => {
    if (insuranceOptionAvailable) {
      getInsuranceInformation();
    }
  }, [getInsuranceInformation, insuranceOptionAvailable]); //user selects insurance

  const {
    trigger: applyInsurance,
    lastError: insuranceLastError,
    status: applyInsuranceStatus
  } = useAsyncStatus(async function applyInsurance(isInsuranceSelected) {
    const req = await fetch([API_HOST, "purchases", reservation.purchase.uuid, "insurance/"].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        insurance: isInsuranceSelected
      })
    });
    const purchase = await req.json();

    if (req.ok) {
      setOrderSummary(summary => ({ ...summary,
        ...getOrderSummaryFromPurchase(purchase)
      }));
      setReservation(reservation => ({ ...reservation,
        purchase
      }));
    } else {
      window.alert(t("event.refundProtectionNotAvailable"));
      throw purchase;
    }
  });
  const insuranceDisabled = !insuranceInformation?.price || insuranceLastError != null;
  const co2OffsetOptionAvailable = event.is_co2_usable && event.event_type !== "GIFT_CARD" && !reservation.purchase.purchase_is_free; //user selects co2-offset

  const {
    trigger: applyCO2Offset,
    lastError: co2OffsetLastError,
    status: applyCO2OffsetStatus
  } = useAsyncStatus(async function applyCO2Offset(isCO2OffsetSelected) {
    const req = await fetch([API_HOST, "offset", "purchases", reservation.purchase.uuid, "co2-offset/"].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        is_selected: isCO2OffsetSelected
      })
    });
    const purchase = await req.json();

    if (req.ok) {
      setOrderSummary(summary => ({ ...summary,
        ...getOrderSummaryFromPurchase(purchase)
      }));
      setReservation(reservation => ({ ...reservation,
        purchase
      }));
    } else {
      window.alert(t("event.refundProtectionNotAvailable"));
      throw purchase;
    }
  });
  const co2OffsetDisabled = co2OffsetLastError != null; // Add a state for when the button has been clicked to simulate a form
  // submit action. This is important for the UI for free ticket flow where
  // the purchase needs to be marked as PAID before proceeding to the success
  // page.

  const [continueClicked, setContinueClicked] = React.useState(false); // Reset the state after 2 seconds in case there was an error

  React.useEffect(function () {
    if (continueClicked) {
      setTimeout(function () {
        setContinueClicked(false);
      }, 2000);
    }
  }, [continueClicked]);
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledForm, {
    id: "services",
    onSubmit: function (e) {
      e.preventDefault();
      const isSuccess = onSuccess();

      if (isSuccess) {
        setContinueClicked(true);
      }
    }
  }, insuranceOptionAvailable && /*#__PURE__*/React.createElement("fieldset", {
    form: "services",
    onChange: e => {
      // @ts-ignore: TODO: Correct types for input change
      applyInsurance(e.target.value === "yes");
    }
  }, /*#__PURE__*/React.createElement(_StyledP, {
    _css: servicesStyles.textBold
  }, t("event.protectOrder") + " - ", insuranceInformationStatus === AsyncStates.Success ? /*#__PURE__*/React.createElement(React.Fragment, null, whitelabel.numberFormat(insuranceInformation?.price)) : insuranceInformationStatus === AsyncStates.Error ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("event.failedFetchingQuote") + " "), /*#__PURE__*/React.createElement(_StyledU, {
    onClick: getInsuranceInformation
  }, t("event.tryAgain"), ".")) : /*#__PURE__*/React.createElement("i", null, "...", t("event.fetchingQuote"), "..."), " "), /*#__PURE__*/React.createElement(_StyledP2, {
    _css2: servicesStyles.textSmall
  }, t("event.fullRefundWithRefundProtection") + " ", /*#__PURE__*/React.createElement("a", {
    href: "/" + language + "/refund-protection",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t("event.readMoreHere")), "."), /*#__PURE__*/React.createElement(_StyledP3, {
    _css3: servicesStyles.textSmall
  }, t("event.addRefundProtectionToOrder") + " ", /*#__PURE__*/React.createElement("a", {
    href: insuranceInformation?.insuranceTermsAndConditionsUrl,
    target: "_blank",
    rel: "noreferrer"
  }, t("event.termsAndConditions").toLowerCase(), ".")), /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(_StyledLabel, {
    _css4: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement(_StyledInput, {
    type: "radio",
    required: true // @ts-ignore: TODO: Correct types for input change
    ,
    value: "yes",
    "data-testid": "insurance_yes",
    name: "insurance",
    defaultChecked: reservation.purchase.insurance && reservation.purchase.insurance.insurance_selected !== null && reservation.purchase.insurance.insurance_selected || false,
    disabled: insuranceDisabled,
    _css5: insuranceDisabled ? {
      cursor: "not-allowed"
    } : undefined
  }), /*#__PURE__*/React.createElement(_StyledDiv3, {
    _css6: insuranceDisabled ? {
      backgroundColor: "white !important",
      borderColor: "#e0e0e0 !important",
      color: "#e0e0e0 !important"
    } : undefined
  }, t("event.yes"))), /*#__PURE__*/React.createElement(_StyledLabel2, {
    _css7: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement(_StyledInput2, {
    type: "radio",
    required: true // @ts-ignore: TODO: Correct types for input change
    ,
    value: "no",
    name: "insurance",
    defaultChecked: reservation.purchase.insurance && reservation.purchase.insurance.insurance_selected !== null && reservation.purchase.insurance.insurance_selected === false ? true : undefined,
    disabled: insuranceDisabled,
    _css8: insuranceDisabled ? {
      cursor: "not-allowed"
    } : undefined
  }), /*#__PURE__*/React.createElement(_StyledDiv4, {
    _css9: insuranceDisabled ? {
      backgroundColor: "white !important",
      borderColor: "#e0e0e0 !important",
      color: "#e0e0e0 !important"
    } : undefined
  }, t("event.no"))))), co2OffsetOptionAvailable && /*#__PURE__*/React.createElement("fieldset", {
    form: "services",
    onChange: e => {
      // @ts-ignore: TODO: Correct types for input change
      applyCO2Offset(e.target.value === "yes");
    }
  }, /*#__PURE__*/React.createElement(_StyledP4, {
    _css10: servicesStyles.textBold
  }, t("event.co2Offset", {
    price: whitelabel.numberFormat(whitelabel.fee_per_co2_offset)
  })), /*#__PURE__*/React.createElement(_StyledP5, {
    _css11: servicesStyles.textSmall
  }, t("event.counteractTheClimateEffects")), /*#__PURE__*/React.createElement(_StyledP6, {
    _css12: servicesStyles.textSmall
  }, t("event.offsetAmountWillNotBeReimbursed") + " ", /*#__PURE__*/React.createElement("a", {
    href: language === "da" ? "https://climaider.com/blog/hvad-sker-der-med-dit-bidrag" : "https://en.climaider.com/blog/hvad-sker-der-med-dit-bidrag",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t("event.contributionFor"))), /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(_StyledLabel3, {
    _css13: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement(_StyledInput3, {
    type: "radio",
    required: true // @ts-ignore: TODO: Correct types for input change
    ,
    value: "yes",
    name: "offsetting_program",
    disabled: co2OffsetDisabled,
    _css14: co2OffsetDisabled ? {
      cursor: "not-allowed"
    } : undefined
  }), /*#__PURE__*/React.createElement(_StyledDiv6, {
    _css15: co2OffsetDisabled ? {
      backgroundColor: "white !important",
      borderColor: "#e0e0e0 !important",
      color: "#e0e0e0 !important"
    } : undefined
  }, t("event.yes"))), /*#__PURE__*/React.createElement(_StyledLabel4, {
    _css16: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement(_StyledInput4, {
    type: "radio",
    required: true // @ts-ignore: TODO: Correct types for input change
    ,
    value: "no",
    name: "offsetting_program",
    disabled: co2OffsetDisabled,
    _css17: co2OffsetDisabled ? {
      cursor: "not-allowed"
    } : undefined
  }), /*#__PURE__*/React.createElement(_StyledDiv7, {
    _css18: co2OffsetDisabled ? {
      backgroundColor: "white !important",
      borderColor: "#e0e0e0 !important",
      color: "#e0e0e0 !important"
    } : undefined
  }, t("event.no")))), /*#__PURE__*/React.createElement(_StyledP7, {
    _css19: [servicesStyles.textSmall, {
      marginTop: 20
    }]
  }, t("event.сlimateOffsetting") + " ", /*#__PURE__*/React.createElement("a", {
    href: language === "da" ? "https://climaider.com/about-us" : "https://en.climaider.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t("event.readMoreHere")), "."), /*#__PURE__*/React.createElement(_StyledDiv8, null, /*#__PURE__*/React.createElement(_StyledImg, {
    src: climaiderIcon
  }))), /*#__PURE__*/React.createElement(_StyledDiv9, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: applyInsuranceStatus === AsyncStates.Pending || applyCO2OffsetStatus === AsyncStates.Pending,
    success: continueClicked,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton, {
    type: "submit",
    _css20: [getThemedButton(theme), {
      marginTop: 15
    }]
  }, t("event.continue"))))), /*#__PURE__*/React.createElement(_StyledDiv10, null, /*#__PURE__*/React.createElement(_StyledDiv11, {
    role: "button",
    onClick: function () {
      history.goBack();
    },
    _css21: [styles.textButton, {
      color: "#63696d",
      marginTop: 10,
      fontSize: 12
    }]
  }, t("event.back"))));
}